import type { MarketData, OverlaySpec, PanelSpec } from "../types";
import { ActiveIndicator, getIndicator, registerIndicator } from "./Indicator";
import { CLASSIC_INDICATORS } from "./classic";
import { TICK_INDICATORS } from "./tick";

[...CLASSIC_INDICATORS, ...TICK_INDICATORS].forEach(registerIndicator);

// Ready-made instances shown in the Indicators menu.
export const INDICATOR_PRESETS: ActiveIndicator[] = [
  { key: "sma20", id: "sma", label: "SMA 20", color: "#F5A623", settings: { period: 20 } },
  { key: "sma50", id: "sma", label: "SMA 50", color: "#4C9AFF", settings: { period: 50 } },
  { key: "ema9", id: "ema", label: "EMA 9", color: "#00E68A", settings: { period: 9 } },
  { key: "ema21", id: "ema", label: "EMA 21", color: "#FF6BD6", settings: { period: 21 } },
  { key: "bb20", id: "bb", label: "Bollinger 20/2", color: "#9B59F6" },
  { key: "vwap", id: "vwap", label: "VWAP", color: "#22D3EE" },
  { key: "rsi14", id: "rsi", label: "RSI 14", color: "#9B59F6" },
  { key: "macd", id: "macd", label: "MACD 12/26/9", color: "#4C9AFF" },
  { key: "atr14", id: "atr", label: "ATR 14", color: "#F5A623" },
  { key: "tickSpeed", id: "tickSpeed", label: "Tick Speed", color: "#F5A623" },
  { key: "tickDominance", id: "tickDominance", label: "Tick Dominance", color: "#00E68A" },
  { key: "tickImbalance", id: "tickImbalance", label: "Tick Imbalance", color: "#22D3EE" },
];

export interface IndicatorOutput { overlays: OverlaySpec[]; panels: PanelSpec[] }

export const IndicatorEngine = {
  compute(active: ActiveIndicator[], data: MarketData): IndicatorOutput {
    const out: IndicatorOutput = { overlays: [], panels: [] };
    if (!data.candles.length) return out;
    for (const a of active) {
      const def = getIndicator(a.id);
      if (!def) continue;
      const res = def.calculate(data, { ...def.defaults, ...(a.settings ?? {}) }, a.color);
      if (res.overlays) out.overlays.push(...res.overlays);
      if (res.panel) out.panels.push({ ...res.panel, id: a.key });
    }
    return out;
  },
};
